"use client"

import { Link } from "@/navigation";
import { useEffect, useState } from "react";
import { Providers } from "../../../redux/provider";
import { AppInsightsProvider } from "../../../components/AppInsightsProvider";
export default function OrderLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const [showDiv, setShowDiv] = useState(false);

  /* useEffect(() => {

    const env = useEnv();
    if (env.NODE_ENV as string !== "production") {
      const handleKeyDown = (event: KeyboardEvent) => {
        // Check if the key pressed is the desired key (e.g., "D" key with keyCode 68)
        if (event.key === "d") {
          setShowDiv(true);
        }
      }
  
      const handleKeyUp = (event: KeyboardEvent) => {
        // Check if the key released is the desired key (e.g., "D" key with keyCode 68)
        if (event.key === "d") {
          setShowDiv(false);
        }
      }
  
  
      window.addEventListener("keydown", handleKeyDown);
      window.addEventListener("keyup", handleKeyUp);
  
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
        window.removeEventListener("keyup", handleKeyUp);
      }
    }
  }, []) */


  return (
    <>
      <AppInsightsProvider>
        <Providers>
          {children}
          {showDiv && (
            <div className="mx-auto max-w-7xl text-center">
              <Link href="/order">Step 1</Link>{" "}
              <Link href="/order/contact">Step 2</Link>{" "}
              <Link href="/order/addresses">Step 3</Link>{" "}
              <Link href="/order/invoice">Step 4</Link>{" "}
              <Link href="/order/screedcheck">Step 5</Link>{" "}
              <Link href="/order/confirm">Confirm</Link>
            </div>
          )}
        </Providers>
      </AppInsightsProvider>
    </>
  )
}

